<template>
  <div id="main">
    <div class="infoimg" v-show="showinfo">
        <img class="img" src="../assets/info.png">
        <div class="infotip">{{info}}</div>
    </div>
    <ul v-show="showinfo==false">
        <li v-for="item in list" :key="item.id">
            <div class="infomaina">
                <div class="titlex">
                    {{item.department}}                    
                </div>
                <div class="datex">
                    {{item.starttime}}
                    <span v-bind:class="{'red':item.status=='已取消','orange':item.status=='等待叫号','lightgrey':item.status=='已完成'}">{{item.status}}</span>
                </div>
            </div>
        </li>
    </ul> 
  </div>  
</template>

<script>
import Axios from 'axios'
import qs from 'qs';
import { MessageBox } from 'mint-ui';

export default {
  name: 'main',
  data () {
    return {
      msg: '这里是提交预约页面',  
      showinfo:false,
      info:'',
      openid:'',   
      idnumber:'',   
      wxbaseinfo:{
        name:'',
        departmnet:'',
        serial:'',
        prenum:'',
        visittime:''
      },
      list:[]
    }
  },
  created(){      
    // 1、从缓存读取openid    
    var temopenid= "oym4F6GbgItOvrqilutyj4W-y5Rw";//localStorage.getItem('wxopenid');
    if(temopenid && temopenid!='undefined'){
        // 缓存存在
        this.openid=temopenid;
        // 验证基本信息（是否有姓名）,无信息则完善基本信息
        this.checkInfo();   
    }
    else{
        // 缓存不存在，则跳转到授权页
        this.$router.push({path:'/authtest'});
    } 
  },
  methods:{
    // 验证用户信息
    checkInfo(){
      // 验证个人信息
      var api='http://localhost:6334/api/checkinfo';
      Axios.post(api,qs.stringify({
        'openid':this.openid
        }),{emulateJSON: true},{
          headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}
        }).then(response=>{
              if(response.data.result=='false'){
                  // 出错了，则跳到出错处理页面
                  this.$router.push({path:'/err'});
              }
              else{
                if(response.data.data.name==null || response.data.data.name==''){
                    // 没有姓名信息跳转到完善基本信息
                    // this.$router.push({path:'/baseinfo'})
                    this.$router.push({name:'baseinfo',params:{'openid':response.data.data.openid}});
                }
                else{                    
                  // 信息完事，则正常显示 
                  this.idnumber=response.data.data.idnumber;
                  this.loadappointmentlist();
              }
            }
      }),function(err){
          alert('appointment验证用户失败：' + err);
      }
    },
    // 加载系统提示信息
    loadappointmentlist(){
        var api='http://localhost:6334/api/getappointmentlist?idnumber=' + this.idnumber;
        Axios.get(api).then((response)=>{            
            if(response.data.result=='false'){
                // 无记录
                // this.$router.push({path:'/err'});
                this.info=response.data.errmsg;
                this.showinfo=true;
            }
            else{
                // 解码用 
                this.showinfo=false;
                this.list=response.data.data                
            }
        }).catch((err)=>{
            alert('appointment获取系统信息失败：' + err);
        })
    }
  }
}
</script>

<style>

#main,/*设置占满*/
html,
body {
  background-color: #f4f4f4;
  width: 100%;
  height: 100%;
  margin: 0;
}
.infomaina{
  width: 75%;
  height:80px;
  background-color:white;
  font-family: Arial; 
  border: 1px solid #f4f4f4; 
  border-radius: 10px; 
  padding: 30px 30px; 
  margin: 5%;
}
.titlex{
  font-size: 21px;
}
.red{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:red;
}
.orange{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:orange;
}
.lightgrey{ 
  font-size: 20px;
  float:right; 
  width:80px; 
  color:lightgray;
}
.datex{
  font-size: 18px;
  color: darkgray;
  float:left; 
}
.infodetail{
    top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/appointlist.vue